import { BrowserModule, Title, BrowserTransferStateModule } from '@angular/platform-browser';
import {NgModule, LOCALE_ID, APP_INITIALIZER} from '@angular/core';
import {TransferHttpCacheModule} from '@nguniversal/common';
import {registerLocaleData} from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeGB from '@angular/common/locales/en-GB';
import {AppRoutingModule} from './app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppComponent} from './app.component';
import {HeaderComponent} from './Components/header/header.component';
import {FooterComponent} from './Components/footer/footer.component';
import {NotFoundComponent} from './Components/not-found/not-found.component';
import {SocialLoginModule, AuthServiceConfig} from 'angularx-social-login';
import {SocialAuthServiceConfigs} from './Configs/social.config';
import {WebAppConfiguration} from './Configs/webapp.config';
import {cookieConfig} from './Configs/cookieConsent.config';
import {CountriesConfiguration} from './Configs/countries.config';
import {AuthguardService} from './Services/authguard/authguard.service';
import {IpService} from './Services/ip/ip.service';
import {SharedModule} from './Modules/shared/shared.module';
import {DomService} from './Services/dom/dom.service';
import {FooterService} from './Services/footer/footer.service';
import {LangService} from './Services/lang/lang.service';
import {ConfigService} from './Services/config/config.service';
import {CountriesService} from './Services/countries/countries.service';
import {environment} from '../environments/environment';
import {WINDOW_PROVIDERS} from './Services/window/window.service';
import {NgcCookieConsentModule} from 'ngx-cookieconsent';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { TokenInterceptor } from './Services/token/token.interceptor';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        NotFoundComponent,
    ],
    imports: [
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        NgcCookieConsentModule.forRoot(cookieConfig),
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        SocialLoginModule,
        SharedModule,
        BrowserTransferStateModule,
        TransferHttpCacheModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAnalyticsModule,
    ],
    providers: [
        {provide: AuthServiceConfig, useFactory: SocialAuthServiceConfigs},
        AuthguardService,
        IpService,
        DomService,
        Title,
        LangService,
        WINDOW_PROVIDERS,
        FooterService,
        {provide: LOCALE_ID, useValue: 'en'},
        {provide: LOCALE_ID, useValue: 'de'},
        {provide: APP_INITIALIZER, useFactory: CountriesConfiguration, deps: [HttpClient, CountriesService], multi: true},
        {provide: APP_INITIALIZER, useFactory: WebAppConfiguration, deps: [HttpClient, ConfigService], multi: true},
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    ],
    bootstrap: [AppComponent],
    exports: []
})
export class AppModule {
    constructor() {
        registerLocaleData(localeGB, 'en');
        registerLocaleData(localeDE, 'de');
    }
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, environment.apiUrl.baseUrl + '2.0/content/language?platform=webapp&language_code=', '');
}
